import { QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import "style/style";
import { queryClient } from "services/HttpService";
import DashboardReportViewPaged from "./DashboardReportViewPaged";

const ReportGenerationPage = () => (
  <QueryClientProvider client={queryClient}>
    <DashboardReportViewPaged />
    {/* <ReactQueryDevtools initialIsOpen={false} /> */}
  </QueryClientProvider>
);

export default ReportGenerationPage;
